import { RegistrationStep } from 'types/enums/forms/registration/registrationWizard';

export enum PROFESSIONS {
    PHYSICIAN_POST_TRAINING = 1,
    PHYSICIAN_IN_TRAINING_RESIDENT_FELLOW = 190,
    PHYSICIAN_ASSISTANT = 2,
    DENTAL_PROFESSIONAL = 3,
    NURSING_PROFESSIONAL = 4,
    PHARMACY_PROFESSIONAL = 7,
    ADMINISTRATOR = 16,
    LABORATORY_CLINICAL_RESEARCHER = 18,
    EYE_CARE_PROFESSIONAL = 25,
    MEDICAL_STUDENT = 27,
    PUBLIC_HEALTH = 40,
    PATIENT_CONSUMER = 42,
    VETERINARIAN = 166,
    BIOMEDICAL_ENGINEER = 185,
    MIDWIFE = 186,
    MEDICAL_TECHNOLOGIST_ALLIED_HEALTH = 187,
    OTHER_CLINICAL_HEALTHCARE_PROFESSIONAL = 188,
    NON_CLINICAL_HEALTHCARE_PROFESSIONAL = 189,
    AYUSH_DOCTOR_PRACTIONER = 191,
}

export const PHYSICIAN_PROFESSION_GROUP = [
    PROFESSIONS.PHYSICIAN_POST_TRAINING,
    PROFESSIONS.PHYSICIAN_IN_TRAINING_RESIDENT_FELLOW,
];

export const USA_MEDICAL_NUMBER_REQUIRED_GROUP = [
    ...PHYSICIAN_PROFESSION_GROUP,
    PROFESSIONS.PHYSICIAN_ASSISTANT,
    PROFESSIONS.NURSING_PROFESSIONAL,
    PROFESSIONS.PHARMACY_PROFESSIONAL,
    PROFESSIONS.DENTAL_PROFESSIONAL,
    PROFESSIONS.EYE_CARE_PROFESSIONAL,
];

export const USA_MEDICAL_NUMBER_OPTIONAL_GROUP = [
    PROFESSIONS.OTHER_CLINICAL_HEALTHCARE_PROFESSIONAL,
    PROFESSIONS.MEDICAL_TECHNOLOGIST_ALLIED_HEALTH,
];

export const REGISTRATION_STEP = {
    [RegistrationStep.PersonalDetails]: 'personal-details',
    [RegistrationStep.ProfessionalDetails]: 'professional-details',
    [RegistrationStep.ContactDetails]: 'contact-details',
    [RegistrationStep.Identity]: 'identity',
    [RegistrationStep.Address]: 'finish',
};
